import * as Sentry from '@sentry/react';

export const initSentry = () => {
  const sentryConfig = window.toolboxConfig.sentry;
  if (!sentryConfig) return;

  Sentry.init({
    dsn: sentryConfig.dsn,
    environment: sentryConfig.environment,
  });
};
